import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Person } from "../person/person";
import { Organisation } from "./organisation";

export enum RequestType {
    ChatCompletion = "ChatCompletion",
    ImageTranscript = "ImageTranscript",
    ChatStreaming = "ChatStreaming",
}

export class ChatAudit extends BaseEntity<ChatAudit> {
    public chatAuditId!: number;
    public organisationId?: number;
    public personId!: number;
    public conversationId!: string;
    public subject!: string;
    public modelName!: string;
    public startTime!: Date;
    public endTime!: Date;
    public updateTime!: Date;
    public inputTokens!: number;
    public cachedTokens!: number;
    public outputTokens!: number;
    public reasoningTokens!: number;
    public deleted!: boolean;
    public requestType!: RequestType;

    public organisation?: Organisation;
    public person!: Person;
}

export const ChatAuditBreezeModel = new BreezeModelBuilder("ChatAudit", ChatAudit)
    .hasSource()
    .isOrganisationEntity()
    .build();
